// Medusa no devuelve las variantes ordenadas por precio (variant_rank viene
// repetido en casi todos los productos). Ordenamos de menor a mayor precio para
// que la variante por defecto (variants[0]) y el orden de opciones sea consistente.
function variantPrice(variant) {
  if (variant?.calculated_price?.calculated_amount != null) {
    return Number(variant.calculated_price.calculated_amount);
  }
  const prices = variant?.prices || [];
  const mxn = prices.find(p => p.currency_code?.toLowerCase() === 'mxn') || prices[0];
  return mxn?.amount != null ? Number(mxn.amount) : Infinity;
}

// Muta y devuelve el producto (o lista) con sus variantes ordenadas por precio.
export function sortVariantsByPrice(productOrList) {
  const list = Array.isArray(productOrList) ? productOrList : [productOrList];
  for (const p of list) {
    if (Array.isArray(p?.variants) && p.variants.length > 1) {
      p.variants.sort((a, b) => variantPrice(a) - variantPrice(b));
    }
  }
  return productOrList;
}
